import { render, staticRenderFns } from "./PhraseList.vue?vue&type=template&id=53632e10&scoped=true&"
import script from "./PhraseList.vue?vue&type=script&lang=js&"
export * from "./PhraseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53632e10",
  null
  
)

export default component.exports